(() => {
  let cartCount;
  const readCount = html => {
    const node = html.querySelector('[data-cl-cart-count]');
    return node ? Number(node.dataset.clCartCount) : null;
  };
  const updateCartCount = event => {
    for (const html of Object.values(event.cartData?.sections || {})) {
      if (typeof html !== 'string') continue;
      const count = readCount(new DOMParser().parseFromString(html, 'text/html'));
      if (count === null) continue;
      cartCount = count;
      document.dispatchEvent(new Event('cl:cart-offer'));
      break;
    }
  };
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, updateCartCount);
  if (!customElements.get('cl-offer-price')) {
    customElements.define('cl-offer-price', class extends HTMLElement {
      connectedCallback() {
        if (cartCount === undefined) cartCount = Number(this.dataset.cartCount || 0);
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.strings = this.querySelector('template').content;
        this.button = this.productInfo.querySelector('product-form [name="add"]');
        this.quantity = this.productInfo.querySelector('input[name="quantity"]');
        this.sync = this.sync.bind(this);
        this.quantity?.addEventListener('change', this.sync);
        document.addEventListener('cl:cart-offer', this.sync);
        this.buttonObserver = new MutationObserver(this.sync);
        if (this.button) this.buttonObserver.observe(this.button, {attributes:true,attributeFilter:['disabled','aria-disabled']});
        queueMicrotask(this.sync);
      }
      text(selector) { return this.strings.querySelector(selector)?.textContent || ''; }
      sync() {
        if (!this.isConnected || Date.now() / 1000 > Number(this.dataset.end)) return;
        const quantity = Math.max(1, Number(this.quantity?.value || 1));
        const pair = cartCount + quantity >= 2;
        const price = pair ? this.dataset.pair : this.dataset.single;
        const currentPrice = this.querySelector('[data-cl-current-price]');
        if (currentPrice.textContent !== price) currentPrice.textContent = price;
        const saving = this.querySelector('[data-cl-current-off]');
        const savingText = this.text(pair ? '[data-save-40]' : '[data-save-30]');
        if (saving.textContent !== savingText) saving.textContent = savingText;
        this.querySelectorAll('[data-cl-tier]').forEach(tier => tier.toggleAttribute('data-active', tier.dataset.clTier === (pair ? 'pair' : 'single')));
        this.querySelectorAll('[data-active]').forEach(tier => tier.dataset.active = 'true');
        const context = this.querySelector('[data-cl-offer-context]');
        context.hidden = !pair;
        context.textContent = this.text(cartCount >= 1 ? '[data-ready]' : '[data-two]');
        if (!this.button) return;
        let amount = this.button.querySelector('[data-cl-atc-price]');
        if (!amount) {
          amount = document.createElement('span');
          amount.className = 'cl-atc-price';
          amount.dataset.clAtcPrice = '';
          const value = document.createElement('span');
          value.dataset.clAtcValue = '';
          const badge = document.createElement('small');
          amount.append(value, badge);
          this.button.insertBefore(amount, this.button.querySelector('.loading__spinner'));
        }
        amount.hidden = this.button.disabled;
        const value = amount.querySelector('[data-cl-atc-value]');
        const buttonPrice = quantity > 1 ? `${quantity} × ${price}` : price;
        if (value.textContent !== buttonPrice) value.textContent = buttonPrice;
        const badge = amount.querySelector('small');
        const label = this.text(pair ? '[data-button-40]' : '[data-button-30]');
        if (badge.textContent !== label) badge.textContent = label;
      }
      disconnectedCallback() {
        this.quantity?.removeEventListener('change', this.sync);
        document.removeEventListener('cl:cart-offer', this.sync);
        this.buttonObserver?.disconnect();
      }
    });
  }
  const init = () => {
    const root = document.querySelector('[data-cl-welcome]');
    if (root && !/\/(cart|checkouts)(\/|$)/.test(location.pathname)) {
      const overlay = root.querySelector('[data-cl-welcome-overlay]');
      const dialog = root.querySelector('[data-cl-welcome-dialog]');
      const teaser = root.querySelector('[data-cl-welcome-teaser]');
      let focusBefore;
      const targets = () => Array.from(dialog.querySelectorAll('button, a[href], summary')).filter(el => !el.disabled && el.getClientRects().length);
      const close = () => {
        overlay.hidden = true;
        teaser.hidden = false;
        teaser.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('cl-welcome-open');
        focusBefore?.focus?.();
      };
      teaser.hidden = false;
      teaser.addEventListener('click', () => {
        if (document.querySelector('cart-drawer.active, .menu-drawer-container[open]')) return;
        focusBefore = document.activeElement;
        overlay.hidden = false;
        teaser.hidden = true;
        teaser.setAttribute('aria-expanded', 'true');
        document.body.classList.add('cl-welcome-open');
        (targets()[0] || dialog).focus();
      });
      root.querySelector('[data-cl-welcome-close]').addEventListener('click', close);
      overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
      document.addEventListener('keydown', event => {
        if (overlay.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const list = targets();
        if (event.shiftKey && document.activeElement === list[0]) { event.preventDefault(); list.at(-1)?.focus(); }
        else if (!event.shiftKey && document.activeElement === list.at(-1)) { event.preventDefault(); list[0]?.focus(); }
      });
    }
    const footer = document.querySelector('#main-cart-footer');
    if (footer) new IntersectionObserver(entries => document.body.classList.toggle('cl-cart-footer-visible', entries[0].isIntersecting)).observe(footer);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
